import downDirection from "../../assets/downDirection.jpg";
import leftDirection from "../../assets/leftDirection.jpg";
import rightDirection from "../../assets/rightDirection.jpg";
import upDirection from "../../assets/upDirection.jpg";
import { Dialog } from "../../components/CommonComponents/Dialog/Dialog";

export const availableDirections = [
  {
    id: "1",
    direction: downDirection,
  },
  {
    id: "2",
    direction: leftDirection,
  },
  {
    id: "3",
    direction: upDirection,
  },
  {
    id: "4",
    direction: rightDirection,
  },
];

export default function SelectDirection({
  onClose,
  onSelect,
  selected,
  isLevel3 = false,
}: {
  onClose: () => unknown;
  selected?: string | number;
  onSelect: (id: number | string) => unknown;
  isLevel3?: boolean;
}) {
  let toRender = (
    <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-4">
      {availableDirections?.map((e) => (
        <button
          key={e.id}
          type="button"
          onClick={() => onSelect(e.id)}
          className={`p-4 flex justify-center items-center rounded-lg ${
            selected === e.id ? "bg-primary text-white" : "bg-white"
          } hover:bg-gray-200 transition-colors`}
        >
          <img src={e?.direction} className="max-w-full h-auto" alt="direction" />
        </button>
      ))}
    </div>
  );

  return (
    <Dialog onClose={onClose} open className="fixed inset-0 z-50 overflow-auto 
    bg-black bg-opacity-0 flex items-center justify-center">
      <div className="bg-white rounded-lg p-6 w-full max-w-3xl max-h-[90vh] overflow-auto">
      <div className="mb-4 flex justify-between items-center relative">
  <div className="absolute right-0">
    <button className="text-xl p-2" onClick={onClose}>
      <i className="fa fa-close"></i>
    </button>
  </div>
  <h4 className="m-0 text-2xl font-bold w-full text-center">Select Direction</h4>
</div>
        {toRender}
      </div>
    </Dialog>
  );
}
